import React from 'react';
import Panel from './Panel';
import * as styles from './HeroPanel.module.scss';
import { Gender } from '../configs';
import { clsx } from '../utils/utils';

export interface HeroPanelProps {
  currentGender: Gender;
  maleHeroImage: any;
  femaleHeroImage: any;
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
}

const HeroPanel = ({
  currentGender,
  maleHeroImage,
  femaleHeroImage,
  onClick,
  children,
  className,
}: HeroPanelProps): React.ReactElement => {
  return (
    <Panel infoSysPortal className={className} onClick={onClick}>
      <img
        className={clsx(styles.heroImage, currentGender === 'male' && styles.visible)}
        src={maleHeroImage}
      ></img>
      <img
        className={clsx(styles.heroImage, currentGender === 'female' && styles.visible)}
        src={femaleHeroImage}
      ></img>
      {children}
    </Panel>
  );
};

export default HeroPanel;
